import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { useQuery } from '@apollo/react-hooks';
import { GET_FAVORITES_PRODUCTS } from '../../queries';
import { getProductsWithOneImage } from '../../utils/misc';
import ProductList from '../product-list/product-list';

const Favorites = () => {
  const { loading, data, error } = useQuery(GET_FAVORITES_PRODUCTS, {
    fetchPolicy: 'network-only'
  });
  if (loading) {
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress/>
      </div>
    );
  }

  if (error) {
    return <p>Помилка при завантаженні продуктів</p>;
  }

  const favoriteProducts = getProductsWithOneImage(data.favoriteProducts);

  return (
    <div>
      <h2>Улюблені</h2>
      {favoriteProducts && favoriteProducts.length ? (
        <ProductList products={favoriteProducts}/>
      ) : (
        <h3>Немає улюблених продуктів</h3>
      )}
    </div>
  );
};

export default Favorites;
